import { getFlashCookie } from "@impero-com/common/utils/flash";
import { getDomainName } from "@impero-com/common/utils/url";

import { WebRoute } from "../routes";

export function getOrganizationSelectionUrl() {
    const currentUrl = new URL(window.location.href);
    const flashPath = getFlashCookie()?.match(/^7:success(.*)$/)?.[1];
    const returnUrl =
        currentUrl.pathname === WebRoute.OAUTH_AUTHORIZE
            ? currentUrl
            : new URL(flashPath ?? "/", currentUrl.origin);
    const selectionUrl = new URL(`https://login.${getDomainName()}`);

    if (returnUrl.pathname === WebRoute.OAUTH_AUTHORIZE) {
        selectionUrl.pathname = WebRoute.OAUTH_AUTHORIZE;
        selectionUrl.search = returnUrl.search;
    }
    selectionUrl.searchParams.set("reset", "true");
    return selectionUrl.toString();
}
